import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelpersService } from "./helpers.service";
import { catchError, map, Observable, of, throwError } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable()

export class BackofficeService extends HelpersService {
    constructor(router: Router, http: HttpClient, translate: TranslateService, dialog: MatDialog) {
        super(router, http, translate, dialog)
    }

    public getLangs(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/translation/languages`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public clearCache(): Observable<any> {
        return this.http.delete(`${this.config.BASEURL_SETTINGS_API}/v1/secured/translation/cache?warmup=true`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public clearCacheLang(lang: string): Observable<any> {
        return this.http.delete(`${this.config.BASEURL_SETTINGS_API}/v1/secured/translation/cache?locale=${lang}&warmup=true`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public clearCacheSQ(): Observable<any> {
        return this.http.delete(`${this.config.BASEURL_SETTINGS_API}/v1/secured/security-questions/cache`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }

    public saveSettings(req: any): Observable<any> {
        return this.http.put(`${this.config.BASEURL_SETTINGS_API}/v1/secured/settings`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
            })
        )
    }
}